export const editorOptions = {
  height: 500,
  menubar: false,
  paste_data_images: true,
  plugins: [
    'advlist autolink lists link image charmap print preview anchor',
    'searchreplace visualblocks code fullscreen',
    'insertdatetime media table paste code help wordcount',
  ],
  toolbar: `undo redo | formatselect | bold italic backcolor | alignleft aligncenter 
    alignright alignjustify | bullist numlist outdent indent code | removeformat | help`,
  content_style:
    '@import url(https://fonts.googleapis.com/css2?family=Open+Sans&family=Source+Sans+Pro:ital,wght@0,600;0,700;1,400&display=swap;); body { font-family: "Open Sans", Helvetica, Arial,sans-serif; font-size:14px } h1,h2,h3,h4 {font-family: "Source Sans Pro", Helvetica, Arial, sans-serif;}',
};



// WEBPACK FOOTER //
// src/components/shared/RichEditor/options.js